// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"69b60f6f","128":"14eed67b","156":"1cb5dddd","213":"08462194","282":"3afa55bd","434":"d04860fe","453":"4d6ed93c","484":"0a188285","485":"4840f40b","512":"873b84d5","557":"9c76afae","594":"cd134221","709":"cf8923f1","723":"d4607eec","837":"6a7ee685","947":"16a9e31b"}[chunkId] + ".chunk.js";
};